export default "__VITE_ASSET__D9bZLBQD__"